import { httpClient } from "../../../shared/api";

function cleanQuery(query = {}) {
  const out = {};
  Object.entries(query).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    out[k] = v;
  });
  return out;
}

export const epicsApi = {
  list(params = {}) {
    return httpClient.get("/epics", { query: cleanQuery(params) });
  },

  getById(epicId) {
    return httpClient.get(`/epics/${epicId}`);
  },

  create(payload) {
    return httpClient.post("/epics", payload);
  },

  update(epicId, payload) {
    return httpClient.patch(`/epics/${epicId}`, payload);
  },

  listProjects() {
    return httpClient.get("/projects", { query: { active_only: true } });
  },

  listTeamPlans(epicId) {
    return httpClient.get(`/epics/${epicId}/teams`);
  },

  createTeamPlan(epicId, payload) {
    return httpClient.post(`/epics/${epicId}/teams`, payload);
  },

  updateTeamPlan(teamPlanId, payload) {
    return httpClient.patch(`/epics/teams/${teamPlanId}`, payload);
  },

  deleteTeamPlan(teamPlanId) {
    return httpClient.delete(`/epics/teams/${teamPlanId}`);
  },

  listReleasePlans(epicId) {
    return httpClient.get(`/epics/${epicId}/release-plans`);
  },

  upsertReleasePlans(epicId, plans) {
    return httpClient.put(`/epics/${epicId}/release-plans`, { plans });
  },

  listTeams() {
    return httpClient.get("/teams");
  },

  listChecklistTemplates(params = {}) {
    return httpClient.get("/epics/checklist-templates", { query: cleanQuery(params) });
  },

  attachChecklistTemplate(epicId, templateId) {
    return httpClient.post(`/epics/${epicId}/checklist-templates/${templateId}/attach`, {});
  },

  listChecklistItems(epicId) {
    return httpClient.get(`/epics/${epicId}/checklist-items`);
  },

  updateChecklistItem(itemId, payload) {
    return httpClient.patch(`/epics/checklist-items/${itemId}`, payload);
  },

  listChecklistItemAttachments(itemId) {
    return httpClient.get(`/attachments/epic_checklist_item/${itemId}`);
  },

  uploadChecklistItemAttachment(itemId, file, caption = "Others") {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("ref_type", "epic_checklist_item");
    fd.append("ref_id", itemId);
    fd.append("caption", caption);
    return httpClient.post("/attachments/upload", fd);
  },

  deleteAttachment(attachmentId) {
    return httpClient.delete(`/attachments/${attachmentId}`);
  },

  bulkCreateSupportEpics(payload) {
    return httpClient.post("/epics/support/bulk-create", payload);
  },
};
